import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';
import HomeFacilityServices from '../services/HomeFacilityServices';
import type { IHomeFacility } from '../constants/interfaces';

const HomeFacilityActions = {
    async getAllFacilities(): Promise<IHomeFacility[]> {
        const data = await HomeFacilityServices.getAll();
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: HomeConstants.HOME_FACILITY_GET_ALL,
            data,
        });
        return data;
    },
};

export default HomeFacilityActions;
